import { useState } from "react";
import { Box, ButtonBase, Grid } from "@mui/material";
import { KeyboardArrowRight } from "@mui/icons-material";
import { useNavigate } from "react-router-dom";
import CustomText from "../components/CustomText";
import CustomButton from "../components/CustomButton";
import ImageLoader from "../components/ImageLoader";

const TypesOfService = () => {
  const navigate = useNavigate();

  const [selected, setSelected] = useState(ServiceItem[0]);

  return (
    <Grid container sx={design.Container}>
      <CustomText variant="subtitle1" color="#162E84" sx={design.Title}>
        Cuida de tu salud y la de tu familia
      </CustomText>
      <Grid container justifyContent="center" sx={design.Content}>
        <Box sx={design.TabsContainer}>
          {ServiceItem.map((item) => {
            const active = selected.name === item.name;
            return (
              <Box sx={design.BoxBoton}>
                <ButtonBase
                  key={item.name}
                  onClick={() => setSelected(item)}
                  sx={design.ButtonB(active, item)}
                >
                  {item.name}
                  {active && (
                    <>
                      <Box className="bridge" />
                      <Box sx={design.CurvaIzq} />
                      <Box sx={design.CurvaDer} />
                    </>
                  )}
                </ButtonBase>
              </Box>
            );
          })}
        </Box>
        <Grid container sx={design.CardColor(selected)}>
          <Grid item size={design.GridImage} sx={design.Align}>
            <ImageLoader
              src={selected.image}
              alt={selected.title}
              width="93%"
              height={"93%"}
              borderRadius={10}
              objectPosition={"30% center"}
            />
          </Grid>
          <Grid item size={design.GridText} sx={design.AlignText}>
            <CustomText color="#FFF" sx={design.CardTitle}>
              {selected.title}
            </CustomText>
            <CustomText color="#FFF" sx={design.CardDescription}>
              {selected.descripCard}
            </CustomText>
            <CustomText color="#FFF" sx={design.CardDescription}>
              {selected.description}
            </CustomText>
            <CustomButton
              variant="contained"
              backgroundColor="#FFFFFF"
              colorTexto={selected.color}
              width="50%"
              height={50}
              borderRadius={14}
              align={true}
              style={design.Buttom}
              onClick={() =>
                navigate(`/servicios?name=${encodeURIComponent(selected.name)}`)
              }
            >
              Conocer más
              <KeyboardArrowRight />
            </CustomButton>
          </Grid>
        </Grid>
      </Grid>
      <Grid container sx={design.AlignImg}>
        <Grid size={design.Grid6} sx={design.GridS}>
          <Box sx={design.TamImgIzq}>
            <ImageLoader
              src={selected.gallery.leftTop.src}
              width="100%"
              height="100%"
              borderRadius={5}
              objectPosition={selected.gallery.leftTop.objectPosition}
            />
          </Box>
          <Box sx={design.TamImgDer}>
            <ImageLoader
              src={selected.gallery.leftBottom.src}
              width="100%"
              height="100%"
              borderRadius={5}
              objectPosition={selected.gallery.leftBottom.objectPosition}
            />
          </Box>
        </Grid>
        {/* Columna derecha */}
        <Grid size={design.Grid6} sx={design.GridPosit}>
          <Box sx={design.TamRigth}>
            <ImageLoader
              src={selected.gallery.rightTop.src}
              width="100%"
              height="100%"
              borderRadius={5}
              objectPosition={selected.gallery.rightTop.objectPosition}
            />
          </Box>
          <Box sx={design.TamLeft}>
            <ImageLoader
              src={selected.gallery.rightBottom.src}
              width="100%"
              height="100%"
              borderRadius={5}
              objectPosition={selected.gallery.rightBottom.objectPosition}
            />
          </Box>
        </Grid>
      </Grid>
    </Grid>
  );
};

export default TypesOfService;

const design = {
  Container: {
    width: "100%",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "center",
    py: 8,
    px: 2,
  },
  Content: {
    width: "100%",
    mt: 5,
    flexDirection: "column",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
  },
  Title: {
    fontFamily: "Nunito",
    fontWeight: 800,
    textAlign: "center",
    lineHeight: 1.2,
    mb: 2,
    fontSize: {
      xs: 26,
      sm: 34,
      md: 42,
      lg: 48,
    },
  },
  BoxBoton: { flexDirection: "column", display: "flex" },
  TabsContainer: {
    display: "flex",
    justifyContent: "center",
    alignItems: "flex-end",
    flexWrap: "wrap",
    gap: 3,
    position: "relative",
    zIndex: 5,
    mb: "10px",
  },
  GridImage: {
    xs: 12,
    md: 6,
  },
  GridText: {
    xs: 12,
    md: 6,
  },
  CardTitle: {
    fontFamily: "Nunito",
    fontWeight: "bold",
    textAlign: "center",
    mt: 2,
    fontSize: {
      xs: 28,
      md: 38,
    },
  },
  CardDescription: {
    fontFamily: "Nunito",
    textAlign: "justify",
    mb: 2,
    fontSize: {
      xs: 15,
      md: 19,
    },
  },
  ButtonB: (active, item) => ({
    position: "relative",
    overflow: "visible",
    minWidth: 155,
    height: 40,
    px: 3,
    border: "2px solid",
    borderRadius: "10px",
    fontFamily: "Nunito",
    fontWeight: 700,
    fontSize: 15,
    backgroundColor: active ? item.color : "#fff",
    color: active ? "#fff" : item.color,
    borderColor: item.color,
    "& .bridge": active
      ? {
          position: "absolute",
          left: -12,
          right: -2,
          bottom: -39,
          height: 44,
          width: "115%",
          background: item.color,
        }
      : {},
  }),
  CurvaIzq: {
    position: "absolute",
    width: 20,
    height: 35,
    left: {
      xs: -22, // móvil
      sm: -22, // tablet
      md: -22, // 900px+
      lg: -22, // 1200px+ / laptop común
      xl: -22, // pantallas grandes
    },
    // bottom: -23,
    bottom: {
      xs: -23, // móvil
      sm: -23, // tablet
      md: -22, // 900px+
      lg: -23, // 1200px+ / laptop común
      xl: -22.5, // pantallas grandes
    },
    borderBottomRightRadius: 10,
    background: "#fFF",
  },
  CurvaDer: {
    position: "absolute",
    width: 20,
    height: 35,
    right: -22,
    bottom: -23,
    borderBottomLeftRadius: 10,
    background: "#fFF",
  },
  CardColor: (selected) => ({
    spacing: 4,
    marginTop: 1.4,
    maxWidth: 1100,
    minWidth: 1100,
    minHeight: 500,
    maxHeight: 500,
    borderRadius: 6,
    background: `linear-gradient(180deg, ${selected.color} 70%, #FFF 100%)`,
  }),
  Align: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
  },
  AlignText: {
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
    pr: 5,
  },
  Buttom: {
    marginTop: 10,
    fontFamily: "Nunito",
    fontWeight: "bold",
  },
  AlignImg: {
    display: "flex",
    justifyContent: "center",
    alignContent: "center",
    mt: 3,
  },
  GridS: {
    display: "flex",
    flexDirection: "column",
    gap: 3,
  },
  Grid6: {
    xs: 12,
    md: 6,
    xl: 6,
    lg: 6,
  },
  TamImgIzq: {
    width: 350,
    height: 507,
  },
  TamImgDer: {
    width: 509,
    height: 285,
  },
  GridPosit: {
    display: "flex",
    flexDirection: "column",
    alignItems: "flex-end",
    gap: 3,
    ml: -7,
  },
  TamRigth: {
    width: 551,
    height: 379,
  },
  TamLeft: {
    width: 415,
    height: 415,
  },
};

const ServiceItem = [
  {
    name: "Torre medica",
    color: "#782A9F",
    title: "Torre Médica",
    descripCard:
      "En nuestra Torre Médica, combinamos tecnología de vanguardia con un equipo de especialistas comprometidos con tu bienestar.",
    description:
      "Aquí recibirás una atención personalizada y profesional, diseñada para atender tus necesidades de salud con excelencia y cercanía.",
    image:
      "https://centromedicomedam.com/IMG/centromedicoMEDAM/Torre_Medica_del_centro-medico_MEDAM.jpg",
    gallery: {
      leftTop: {
        src: "https://centromedicomedam.com/IMG/centromedicoMEDAM/Consultorio_ginecologico_vertical.png",
        objectPosition: "75% center",
      },
      leftBottom: {
        src: "https://centromedicomedam.com/IMG/centromedicoMEDAM/Consultorio_Ginecologico.png",
        objectPosition: "1% center",
      },
      rightTop: {
        src: "https://centromedicomedam.com/IMG/centromedicoMEDAM/Puertas_Consultorios.png",
        objectPosition: "1% center",
      },
      rightBottom: {
        src: "https://centromedicomedam.com/IMG/centromedicoMEDAM/Consultorio_privada.png",
        objectPosition: "center",
      },
    },
  },
  {
    name: "Hospitalización",
    color: "#489E4D",
    title: "Hospitalización",
    descripCard:
      "En nuestra área de hospitalización, cuidamos de ti con la misma dedicación con la que lo haríamos por alguien de nuestra familia.",
    description:
      "Contamos con un entorno seguro, tranquilo y confortable, donde nuestro equipo médico y de enfermería trabaja con empatía, profesionalismo y atención personalizada para acompañarte en cada etapa de tu recuperación.",
    image:
      "https://centromedicomedam.com/IMG/centromedicoMEDAM/Hospitalizacion_detalles_del_centro-medico_MEDAM.png",
    gallery: {
      leftTop: {
        src: "https://centromedicomedam.com/IMG/centromedicoMEDAM/Entradahabitacion.png",
        objectPosition: "55% center",
      },
      leftBottom: {
        src: "https://centromedicomedam.com/IMG/centromedicoMEDAM/Habitacion.png",
        objectPosition: "center",
      },
      rightTop: {
        src: "https://centromedicomedam.com/IMG/centromedicoMEDAM/Habitacion_principal_medam.png",
        objectPosition: "75% center",
      },
      rightBottom: {
        src: "https://centromedicomedam.com/IMG/centromedicoMEDAM/Habitacion_Basica.png",
        objectPosition: "75% center",
      },
    },
  },
  {
    name: "Urgencias",
    color: "#D32D2D",
    title: "Urgencias",
    descripCard:
      "En nuestra área de Urgencias, estamos disponibles las 24 horas del día con un equipo médico preparado para atenderte en los momentos más críticos.",
    description:
      "Contamos con personal capacitado y equipamiento adecuado para resolver la mayoría de las situaciones urgentes de forma rápida, segura y con trato humano. Porque cuando se trata de tu salud, cada minuto cuenta.",
    image:
      "https://centromedicomedam.com/IMG/centromedicoMEDAM/Urgencias_detalles__del_centro-medico_MEDAM.jpg",
    gallery: {
      leftTop: {
        src: "https://centromedicomedam.com/IMG/centromedicoMEDAM/Quirofano_Horizontal_medam.png",
        objectPosition: "10% center",
      },
      leftBottom: {
        src: "https://centromedicomedam.com/IMG/centromedicoMEDAM/Sala_Recuperacon_MEDAM.png",
        objectPosition: "center",
      },
      rightTop: {
        src: "https://centromedicomedam.com/IMG/centromedicoMEDAM/Habitacion_recuperacion_MEDAM.png",
        objectPosition: "center",
      },
      rightBottom: {
        src: "https://centromedicomedam.com/IMG/centromedicoMEDAM/Quirofano_Vertical_MEDAM.png",
        objectPosition: "45% center",
      },
    },
  },
  {
    name: "Laboratorio Clínico",
    color: "#215DA6",
    title: "Laboratorio Clínico",
    descripCard:
      "Nuestro laboratorio clínico es el punto de partida para un diagnóstico confiable. Con tecnología de punta y personal capacitado, garantizamos resultados precisos para que cada paso de tu tratamiento esté respaldado por el profesionalismo que mereces.",
    description:
      "Es por eso que, para cumplir con ese objetivo, nos aliamos con Laboratorio Clínico Durán, uno de los laboratorios más prestigiosos, reconocido por su excelencia y compromiso con la salud.",
    image:
      "https://centromedicomedam.com/IMG/centromedicoMEDAM/Laboratorio_Clinico_del_centro-medico_MEDAM.jpg",
    gallery: {
      leftTop: {
        src: "https://centromedicomedam.com/IMG/centromedicoMEDAM/cafeteria_del_centro-medico_MEDAM.png",
        objectPosition: "75% center",
      },
      leftBottom: {
        src: "https://centromedicomedam.com/IMG/centromedicoMEDAM/cafeteria_del_centro-medico_MEDAM.png",
        objectPosition: "75% center",
      },
      rightTop: {
        src: "https://centromedicomedam.com/IMG/centromedicoMEDAM/cafeteria_del_centro-medico_MEDAM.png",
        objectPosition: "75% center",
      },
      rightBottom: {
        src: "https://centromedicomedam.com/IMG/centromedicoMEDAM/cafeteria_del_centro-medico_MEDAM.png",
        objectPosition: "75% center",
      },
    },
  },
];
